import React from "react"
import styled from "styled-components"
import { theme } from "@/common/Mixin"

import { Swiper, SwiperSlide } from "swiper/react"

import { Pagination, EffectFade, Autoplay } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/effect-fade"
import Introduction, { IntroductionProps } from "./Introduction"

interface DataSwiperProps {
  items: IntroductionProps[]
  barPosition?: "left" | "right"
  style?: React.CSSProperties
}

export default function DataSwiper({
  items,
  barPosition = "right",
  style
}: DataSwiperProps) {
  return (
    <Wrapper style={style} className="kg-wrapper" barPosition={barPosition}>
      <BGWrapper barPosition={barPosition} />
      <Swiper
        slidesPerView={"auto"}
        pagination={{
          clickable: true
        }}
        modules={[Pagination, EffectFade, Autoplay]}
        className="mySwiper"
        effect={"fade"}
        autoplay={{
          delay: 4000,
          disableOnInteraction: true
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={`${item.titleh1}_${index}`}>
            <CardWrapper>
              <Introduction {...item} />
            </CardWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
    </Wrapper>
  )
}

interface WrapperProp {
  barPosition: "left" | "right"
}

const BGWrapper = styled.div<WrapperProp>`
  background: ${theme.gradient.light};
  top: 5vh;
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 24px;
  transform: ${({ barPosition }) =>
    barPosition === "right" ? "translate(60%, 0)" : "translate(-60%, 0)"};

  @media (${theme.lg}) {
    // Legacy style: uncomment to see it
    // transform: translate(0, 0);
    // height: 30%;
    // bottom: 30px;
    // top: unset;
    // left: 0;
    display: none;
  }
`
const Wrapper = styled.div<WrapperProp>`
  width: 100%;
  max-width: 100vw;
  position: relative;
  display: flex;
  padding-top: 3vh;

  .swiper {
    width: 100%;
    max-width: 84vw;
    @media (${theme.lg}) {
      overflow: hidden;
      max-width: calc(100vw - 40px);
      padding-bottom: 30px;
    }
  }
  .swiper-wrapper {
    position: relative;
  }

  .swiper-slide {
    width: 100%;
    /* background-color: ${theme.color.background}; */
    opacity: 0 !important;
    transition:
      translate 1s,
      opacity 0.4s !important ;
    /* transform: translateY(30px) !important; */
    translate: 0 -20px;
    &.swiper-slide-active {
      translate: 0px;
      /* transform: translateY(0px) !important; */
      opacity: 1 !important;
    }
  }
  .swiper-pagination {
    top: 50%;
    right: ${({ barPosition }) => (barPosition === "left" ? "auto" : "0")};
    left: ${({ barPosition }) => (barPosition === "left" ? "0" : "auto")};
    width: 6px;
    transform: translate(0, -50%);
    flex-direction: column;
    display: flex;
    gap: 4px;
    justify-content: center;
    .swiper-pagination-bullet {
      transition: 0.3s;
      background: rgba(255, 255, 255, 0.8);
      opacity: 1;
      margin: 0;
      height: 16px;
      width: 6px;
      border-radius: 10px;
    }
    .swiper-pagination-bullet-active {
      background: ${theme.color.primary};
      height: 80px;
      border-radius: 10px;
    }
    @media (${theme.lg}) {
      flex-direction: row;
      width: 100%;
      top: 0;
      bottom: auto;
      transform: translate(0, 0%);
      justify-content: center;
      .swiper-pagination-bullet {
        background: rgba(255, 255, 255, 0.8);
        opacity: 1;
        margin: 0;
        height: 4px;
        width: 16px;
      }
      .swiper-pagination-bullet-active {
        background: ${theme.color.primary};
        width: 80px;
        border-radius: 10px;
      }
    }
  }
`

const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  @media (${theme.lg}) {
    grid-template-columns: 1fr;
    max-width: calc(100vw - 40px);
    gap: 40px;
  }
`
